import {
  BpmnPropertiesPanelModule,
  BpmnPropertiesProviderModule,
  CamundaPlatformPropertiesProviderModule,
  ZeebePropertiesProviderModule
} from "bpmn-js-properties-panel";
import BpmnModeler from "bpmn-js/lib/Modeler";
import React, { useEffect, useRef, useState } from "react";
import zeebeModdleDescriptors from "zeebe-bpmn-moddle/resources/zeebe.json";
import axiosInstance, { handleApiError } from "../../services/axiosService";

// import "bpmn-js/dist/assets/bpmn-font/css/bpmn-embedded.css";
// import "bpmn-js/dist/assets/diagram-js.css";
import { useParams } from "react-router-dom";
import PageInfoAndActionBar from "../../Layouts/PageInfoAndActionBar";
import { createChecksum } from "../../commonFunctions/fileFolderConfig";
import { useAppOrgContext } from "../../context/AppOrgContext";
import { useTreeContext } from "../../context/TreeDataContext";
import { useWorkflowContext } from "../../context/WorkflowContext";
import "./Workflow.css";
import MaterialIcon from "../../components/BuilderComponents/MaterialIcon";
import { getFolderFileById } from "../../utils/treeData/folderEditorUtils";

const BPMNViewer = () => {
  const containerRef = useRef(null);
  const propertiesPanelRef = useRef(null);
  const isRunModelerRef = useRef(false);
  const [isPropertiesOpen, setIsPropertiesOpen] = useState(false);
  const { selectedWorkflow, setSelectedWorkflow, modelerRef, handleSaveWorkflow } = useWorkflowContext();
  const { workflowExplorerData } = useTreeContext();
  const { currentChecksum } = useAppOrgContext();
  const [diagramChanged, setDiagramChanged] = useState(0);

  const { workflowId } = useParams();

  const fetchSingleWorkflow = async () => {
    const { data } = await axiosInstance.get(`/workflow/${selectedWorkflow.id}`);
    const newChecksum = createChecksum({ xml: data.xml_file });
    currentChecksum.current = newChecksum;
    // const parser = new DOMParser();
    // const xmlDoc = parser.parseFromString(data.xml_file, "text/xml");

    return data.xml_file;
  };

  useEffect(() => {
    if (isRunModelerRef.current) return;
    isRunModelerRef.current = true;
    modelerRef.current = new BpmnModeler({
      container: containerRef.current,
      propertiesPanel: {
        parent: propertiesPanelRef.current
      },
      additionalModules: [
        BpmnPropertiesPanelModule,
        BpmnPropertiesProviderModule,
        CamundaPlatformPropertiesProviderModule,
        ZeebePropertiesProviderModule
      ],
      moddleExtensions: {
        zeebe: zeebeModdleDescriptors
      }
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const modeler = modelerRef.current;
    if (modeler) {
      const handleElementChanged = () => {
        setDiagramChanged((pre) => {
          return pre + 1;
        });
      };

      // Subscribe to the 'element.changed' event
      modeler.on("element.changed", handleElementChanged);

      return () => {
        modeler.off("element.changed", handleElementChanged);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modelerRef.current]);
  let defaultDiagram = `
  <?xml version="1.0" encoding="UTF-8"?>
    <bpmn:definitions
      xmlns:bpmn="http://www.omg.org/spec/BPMN/20100524/MODEL"
      xmlns:cmmn="http://www.omg.org/spec/CMMN/20151109/MODEL"
      xmlns:bpmndi="http://www.omg.org/spec/BPMN/20100524/DI"
      xmlns:modeler="http://camunda.org/schema/modeler/1.0"
      id="Definitions_0bfwl6a" targetNamespace="http://bpmn.io/schema/bpmn"
      exporter="Camunda Modeler" exporterVersion="4.12.0"
      modeler:executionPlatform="Camunda Platform"
      modeler:executionPlatformVersion="7.15.0">
        <bpmn:process id="Process_0w0hjid" isExecutable="true" />
        <bpmndi:BPMNDiagram id="BPMNDiagram_1">
          <bpmndi:BPMNPlane id="BPMNPlane_1" bpmnElement="Process_0w0hjid" />
        </bpmndi:BPMNDiagram>
    </bpmn:definitions>
  `;

  const importAndRenderBPMN = async () => {
    console.log(containerRef.current);
    if (!modelerRef.current) return;
    const container = containerRef.current;
    const modeler = modelerRef.current;
    if (!container) return;
    try {
      let XML = await fetchSingleWorkflow();
      if (XML.length === 0) XML = defaultDiagram;
      await modeler.importXML(XML);
      modeler.get("canvas").zoom("fit-viewport");
    } catch (error) {
      console.log(error);
      handleApiError(error);
    }
  };

  useEffect(() => {
    if (!workflowExplorerData) return;
    const file = getFolderFileById(workflowExplorerData, workflowId);
    if (file) {
      setSelectedWorkflow({
        id: file.id,
        name: file.name
      });
    } else {
      throw new Error();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workflowId, workflowExplorerData]);

  useEffect(() => {
    if (workflowId !== selectedWorkflow.id) return;
    importAndRenderBPMN();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedWorkflow.id]);

  return (
    <div className="content_main_section">
      <PageInfoAndActionBar pageName="workflow" savePage={handleSaveWorkflow} currentConfig={[diagramChanged]} />
      <div className="modeler">
        <div ref={containerRef} id="canvas"></div>
        <div className={`bpmn_properties ${isPropertiesOpen ? "open" : "close"}`}>
          <div ref={propertiesPanelRef} id="properties"></div>
          <button className={`open_close_properties`} onClick={() => setIsPropertiesOpen(!isPropertiesOpen)}>
            {isPropertiesOpen ? <MaterialIcon name="east" /> : <MaterialIcon name="west" />}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BPMNViewer;
